<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<div class="login-page" fxLayout="column" fxLayoutAlign="center center">
    @if (!(loginInProgress$|async)) {
        <mat-card appearance="raised" class="login-card mat-elevation-z2">
            <mat-card-header class="mat-headline-small">Log In</mat-card-header>
            <mat-card-content cdkTrapFocus>
                <form name="loginForm" (ngSubmit)="doLogin()" [formGroup]="loginForm" novalidate>
                    @for (auth of (authenticators$ | async); track auth) {
                        @switch (auth) {
                            @case ('password') {
                                <ng-container *ngTemplateOutlet="passwordForm"></ng-container>
                            }
                            @case ('oidc') {
                                <ng-container *ngTemplateOutlet="oidcForm"></ng-container>
                            }
                        }
                    }
                    @if (enableRemember$ | async) {
                        <div class="remember-me">
                            <mat-checkbox formControlName="rememberMe" aria-label="Remember me">
                                Remember me
                            </mat-checkbox>
                        </div>
                    }
                </form>
            </mat-card-content>
        </mat-card>
    } @else {
        <mat-card appearance="raised" class="login-spinner-card mat-elevation-z2">
            <mat-card-header class="mat-headline-small">Logging In...</mat-card-header>
            <mat-card-content fxLayout="column" fxLayoutAlign="center center">
                <mat-spinner class="login-spinner" mode="indeterminate"></mat-spinner>
            </mat-card-content>
        </mat-card>
    }
    -->
</div>


<ng-template #passwordForm>
    <div>
        <div fxLayout="column" cdkTrapFocus cdkTrapFocusAutoCapture="true">

            <mat-form-field hideRequiredMarker="true">
                <mat-label>Username:</mat-label>
                <input matInput type="text"
                       name="username"
                       [formControl]="loginForm.get('username')" placeholder="Username"
                       autocomplete="username"
                       cdkFocusInitial />
            </mat-form-field>

            <mat-form-field>
                <mat-label>Password:</mat-label>
                <input matInput type="password"
                       name="password"
                       [formControl]="loginForm.get('password')"
                       placeholder="Password" autocomplete="current-password" />
            </mat-form-field>

            @if (invalidLogin) {
                <div
                    class="mat-error" role="alert">
                    Login failed. Please try again.
                </div>
            }
        </div>

    </div>

    <div class="login-actions" fxLayout="column" fxLayoutAlign="space-between stretch">

        <button matButton="filled" type="submit" [disabled]="!loginForm.valid">
            Log In
        </button>

        @if (autoLogin$ | async; as autoLogin) {
            @if (autoLogin.guestuser && autoLogin.guestpassword) {
                <button matButton="outlined"
                        type="button"
                        (click)="guestLogin()">
                    Log in as Guest
                </button>
            }
        }

        @if (needsForgotPassword$ | async) {
            <button mat-button
                    color="accent"
                    class="button-link"
                    (click)="forgotPassword()">I forgot my password
            </button>
        }
    </div>
</ng-template>

<ng-template #oidcForm>

    <div class="login-actions" fxLayout="column" fxLayoutAlign="space-between stretch">
        <button matButton="filled" type="button" class="open-id-button" (click)="oauthLogin()">
            {{ openIdButtonText$ | async }}
        </button>

        @if (openIdSignupButtonText$ | async; as signupText) {
            <button
                matButton="outlined"
                type="button"
                class="open-id-button"
                (click)="oauthSignup()">
                {{ signupText }}
            </button>
        }
    </div>

</ng-template>
